module.exports = __webpack_public_path__ + "img/116.57fa456f.gif";